import { render, staticRenderFns } from "./mobileDeclination2.vue?vue&type=template&id=7143c7f7&scoped=true&"
import script from "./mobileDeclination2.vue?vue&type=script&lang=ts&"
export * from "./mobileDeclination2.vue?vue&type=script&lang=ts&"
import style0 from "./mobileDeclination2.vue?vue&type=style&index=0&id=7143c7f7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7143c7f7",
  null
  
)

export default component.exports